
import React from "react";
import { Shield, FileText } from "lucide-react";
import LegalHero from "@/components/legal/LegalHero";
import TableOfContents from "@/components/legal/TableOfContents";
import BackToTop from "@/components/legal/BackToTop";
import PrivacySections from "@/components/privacy/PrivacySections";
import useSEO from "@/hooks/useSEO";
import { STATIC_ROUTE_META } from "@/utils/routeMetadata";

const Privacy = () => {
  const formattedDate = "October 11, 2026";
  
  useSEO(STATIC_ROUTE_META["/privacy"]);
  
  const tableItems = [
    { id: "intro", title: "Introduction", icon: <FileText size={18} /> },
    { id: "collection", title: "Information We Collect", icon: <FileText size={18} /> },
    { id: "usage", title: "How We Use Your Information", icon: <FileText size={18} /> },
    { id: "disclosure", title: "Disclosure of Your Information", icon: <FileText size={18} /> },
    { id: "security", title: "Data Security", icon: <FileText size={18} /> },
    { id: "children", title: "Children's Privacy", icon: <FileText size={18} /> },
    { id: "links", title: "External Links", icon: <FileText size={18} /> },
    { id: "updates", title: "Updates to This Policy", icon: <FileText size={18} /> },
    { id: "contact", title: "Contact Us", icon: <FileText size={18} /> },
  ];
  
  return (
    <div className="min-h-screen">
      <LegalHero 
        title="Privacy Policy"
        subtitle="How we protect and respect your information"
        icon={<Shield size={32} className="text-elfGreen" />}
        date={formattedDate}
      />

      <TableOfContents items={tableItems} />

      <section className="py-12 md:py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto prose prose-lg">
            <PrivacySections />
          </div>
        </div>
      </section>

      <BackToTop />
    </div>
  );
};

export default Privacy;
